export const InquiryModalArrowIcon = require('../../../Icons/arrow-v2.svg').default;
